import React, { Suspense, useState, useEffect } from "react";
import systemListingService from "./SystemListingServices";
import { TerritoriesDrawer } from "../../AssetLinking/MenuDrawer";
import Pagination from "components/Common/newPagination";
import TerritoryUpsert from "./upsert/TerritoryUpsert";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import { CommonUtilities } from "commonUtils";

export default function Territories(param: any) {

  useEffect(() => {

    if (param.activeTab === "Territories") {
      teritorySelect()
    }
    searchFor = '';
    setsearchFor(searchFor);
  }, [param])


  let [searchFor, setsearchFor] = useState("");
  let [listingCount, setListingCount] = useState(0);
  let [editingOn, setEditingOn] = useState<boolean>(false);
  let [territoryList, SetTerritoryListing] = useState<any>([]);
  let [TempTerritoryList, SetTempTerritory] = useState<any>([]);

  var payLoad = {
    pageNumber: 1,
    pageSize: 10
  }

  const teritory_Select = () => {

    if (searchFor.length > 0) {
      console.log(searchFor)

      console.log(TempTerritoryList)
      const temp = TempTerritoryList?.filter((listing: any) =>
        listing?.territoryName?.toLowerCase().includes(searchFor?.toLowerCase()) ||
        listing?.territoryCurrency?.toLowerCase().includes(searchFor?.toLowerCase()) ||
        listing?.territoryCode?.toLowerCase().includes(searchFor?.toLowerCase())
      );
      console.log(temp)
      listingCount = temp.length;
      setListingCount(listingCount)
      territoryList = temp.slice((payLoad.pageNumber - 1) * payLoad.pageSize, payLoad.pageSize * payLoad.pageNumber)
      SetTerritoryListing(territoryList)

    } else {
      SetTerritoryListing(TempTerritoryList);
    }
  }

  const teritorySelect = () => {
    var payload = {
    }
    systemListingService.territoryList(payload).then((res: any) => {
      TempTerritoryList = res
      SetTempTerritory(TempTerritoryList);

      territoryList = res.slice((1 - 1) * 10, (10 * 1));
      SetTerritoryListing(territoryList)

      listingCount = TempTerritoryList.length;
      setListingCount(listingCount)
    })
  }

  const onPageChange = (e: any) => {
    console.log(e)
    console.log(payLoad)

    payLoad.pageSize = e.pageSize
    payLoad.pageNumber = e.pageNumber

    if (searchFor.length > 0) {
      const temp = TempTerritoryList?.filter((listing: any) =>
        listing?.territoryName?.toLowerCase().includes(searchFor?.toLowerCase()) ||
        listing?.territoryCurrency?.toLowerCase().includes(searchFor?.toLowerCase()) ||
        listing?.territoryCode?.toLowerCase().includes(searchFor?.toLowerCase())
      );

      territoryList = temp.slice((payLoad.pageNumber - 1) * payLoad.pageSize, payLoad.pageSize * payLoad.pageNumber);
      SetTerritoryListing(territoryList)
    } else {

      territoryList = TempTerritoryList.slice((payLoad.pageNumber - 1) * payLoad.pageSize, payLoad.pageSize * payLoad.pageNumber);
      SetTerritoryListing(territoryList)
    }
  }

  let [openUpsertUX, setOpenUpsertUX] = useState(false);
  let [editDataDawer, seteditDataDawer] = useState<any>([]);

  const openAddDrawer = (e: any) => {
    editDataDawer = e
    seteditDataDawer(editDataDawer)
    openUpsertUX = true
    setOpenUpsertUX(openUpsertUX)
  };

  const closeUpsertUX = () => {
    setOpenUpsertUX(!openUpsertUX)
  }

  let [deleteData, setDeleteData] = useState<any>([]);
  let [deleteStatus, setDeleteStatus] = useState(false);
  const deleteSelection = (e: any) => {
    console.log(e)
    deleteData = e
    setDeleteData(deleteData)

    deleteStatus = true;
    setDeleteStatus(deleteStatus)
  }

  const deleteConfirmation = (e: any) => {
    console.log(e)

    //e==1 YES
    if (e == 1) {
      systemFormatsList.deleteTerritoryCode(deleteData).then((respond: any) => {
        CommonUtilities.showToastDawer('Territory delete Successfull', 'Success')
      })
    }
    //e==2 NO
    deleteStatus = false;
    setDeleteStatus(deleteStatus)
  }

  return (
    <>

      <div className="content-card ws-12">

        {/* Header */}
        <div className="ws-12">
          <div className="card-title">Territories</div>

          <div className="ws-12 mb">
            <span className="pt mt pull-left">{TempTerritoryList.length} record(s) found  </span>
            <button className="icon-btn info pull-right" id="editModeBtn" type="button" onClick={() => setEditingOn((prev) => !prev)}> {editingOn ? "Edit Mode: On" : "Edit Mode: Off"}  </button>
          </div>
        </div>

        {/* Filter*/}
        <div className=" ws-12 mb">

          <div className="ws-8">
            <div className="text-bold ws-12">Filter</div>
            <input className="ws-8" onChange={(e: any) => { setsearchFor(e.target.value); teritory_Select() }} placeholder="Filter by code, name, currency or region" value={searchFor} />
            <button className="icon-btn primary pbl" type="button" onClick={() => { teritorySelect() }}>  Search  </button>
          </div>

          <div className="ws-4 mt">
            <button className="icon-btn primary fill height35 pull-right" type="button" onClick={() => openAddDrawer({})}> Add Territories</button>
          </div>

        </div>

        {/* Table */}
        <div className="ws-12">

          {territoryList.length > 0 && <><table className={editingOn ? "editing-on newTable" : " newTable"}>
            <thead>
              <tr>
                <th className="col-code forceSingleLine">Territory Code</th>
                <th className="forceSingleLine">Territory Name</th>
                <th className="col-currency forceSingleLine">Territory Currency</th>
                <th >DIM1</th>
                <th >DIM2</th>
                <th >DIM3</th>
                <th className="col-region">System Region</th>
                <th style={{ width: "13%" }}>Operations</th>
              </tr>
            </thead>
            <tbody>
              {territoryList.map((territoryRow: any) => (
                <tr key={territoryRow.territoryCode} className="pm">
                  <td >{territoryRow.territoryCode}</td>
                  <td >{territoryRow.territoryName}</td>
                  <td >{territoryRow.territoryCurrency}</td>
                  <td >{territoryRow.dim1TerritoryCodes}</td>
                  <td >{territoryRow.dim2TerritoryCodes}</td>
                  <td >{territoryRow.dim3TerritoryCodes}</td>
                  <td className="col-region">{territoryRow.systemRegion}</td>
                  <td >
                    <div style={{ pointerEvents: editingOn ? "auto" : "none", opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed", }} >
                      <button className="icon-btn edit" title="Edit" type="button" onClick={() => openAddDrawer(territoryRow)} disabled={!editingOn} >
                        <i className="icon-pencil"></i>
                      </button>
                      <button className="icon-btn delete" title="Delete" type="button" disabled={!editingOn} onClick={() => deleteSelection(territoryRow)}><i className="icon-trash"> </i> </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

            <Pagination totalRow={listingCount} onPageChange={onPageChange} />
          </>}

          {TempTerritoryList.length === 0 && <div className="alert alert-info ws-12 box" >No records to display</div>}

        </div>


      </div>
      {
        (() => {
          if (openUpsertUX) {
            return <TerritoryUpsert openUpsertUX={openUpsertUX} closeDrawer={closeUpsertUX} editDataDawer={editDataDawer} />
          }

          if (deleteStatus) {
            return <DeleteDialogueBox param={deleteStatus} message={"delete the selected account status"} onChange={deleteConfirmation} />
          }
        })()
      }
    </>
  );
}; 